import { useQuery } from "@tanstack/react-query";

import { currentClaims } from "../lib/auth";
import { PortalUser, getDistrict } from "../lib/api";

// The godowns / reports / invitations / users / me hooks are role-agnostic
// — the backend scope-filters them to the caller — so the district head
// reuses exactly what the state head uses.
export {
  DASH,
  fmtInt,
  fullName,
  isPass,
  roleWords,
  shortDate,
  useMe,
  useSHGodowns as useDHGodowns,
  useSHReports as useDHReports,
  useSHInvitations as useDHInvitations,
  useSHUsers as useDHUsers,
  commodityLabel,
} from "../statehead/data";

/** The district this district-head manages, from their JWT scope. */
export function districtScopeId(): number | null {
  const c = currentClaims();
  const s = c?.scopes?.find((x) => x.scope_type === "district");
  return s ? s.scope_id : null;
}

export function useDHDistrict() {
  const id = districtScopeId();
  return useQuery({
    queryKey: ["dh-district", id],
    queryFn: () => getDistrict(id!),
    enabled: id != null,
  });
}

/** The QC agent(s) working a given godown: users with the
 * godown_qc_agent role holding a godown scope for it. */
export function godownAgents(
  users: PortalUser[],
  godownId: number,
): PortalUser[] {
  return users.filter(
    (u) =>
      u.role === "godown_qc_agent" &&
      (u.scopes ?? []).some(
        (s) => s.scope_type === "godown" && s.scope_id === godownId,
      ),
  );
}
